import styled from 'styled-components';

export const InfoWindowBody = styled.div`
	padding: 5px 30px;
`;

export const InfoWindowIcon = styled.div`
	color: #6860e4;
	text-align: center;
	font-family: 'Font Awesome 6 Pro';
	font-size: 70px;
	font-style: normal;
	font-weight: 400;
	line-height: 21px;
	margin-bottom: 28px;
`;

export const InfoWindowIconDescription = styled.div`
	color: #31363a;
	text-align: center;
	font-size: 18px;
	font-weight: bold;
	line-height: 26px;
`;

export const InfoWindowTopicTitle = styled.h6`
	color: #5341c6;
	font-size: 15px;
	margin-top: 21px;
`;

export const InfoWindowTopicBody = styled.p`
	color: #101828;
	font-size: 11px;
	line-height: 21px;
`;

export const SelectAllCheck = styled.div`
	height: 40px;
	margin: 2px;
	padding-right: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 11px;
	font-weight: 500;
	line-height: 11px;
	text-align: left;

	.p-checkbox {
		margin-right: 9px;
	}
`;

export const ButtonBaselineTabs = styled.div`
	button {
		height: 36.39px !important;
	}

	.rounded-left {
		border-radius: 10px 0 0 10px !important;
	}
`;

export const DropdownBaselineTabs = styled.div`
	padding-top: 16px;

	.p-dropdown {
		display: inline-flex;
		height: 38px;
		border-radius: 0 10px 10px 0 !important;
		border: none;
		border-left: 1px solid #ced4da !important;
	}

	.p-dropdown .p-dropdown-label {
		visibility: hidden;
		display: none;
	}

	.p-dropdown .p-dropdown-trigger {
		color: white !important;
		padding-right: 1em;
	}

	.p-dropdown-trigger-icon pi pi-chevron-down p-clickable {
		color: white !important;
	}

	.p-dropdown-label {
		flex: 0 1;
	}
`;

export const BaselineTaskNameFilter = styled.div`
	.p-inputtext,
	.ui-column-filter {
		width: 150px;
	}
`;

export const HeaderButtons = styled.div`
	display: flex;
	align-items: center; /* Vertically centers the content */

	.multi-select-bulk {
		padding: 0px;
		align-items: center;
		gap: 10.5px;
		width: 195px;

		.Select-placeholder {
			padding-left: 10.5px;
		}

		.Select-value {
			.Select-value-label {
				padding-left: 3.5px;
			}
		}

		.Select-menu {
			display: block;
			width: 210px;
			/* Fit all of the menu names */

			border-radius: 6px;
			transition: width 300ms;
			background-color: #f6f9fc;
			border: 1px solid #dee2e6;
			text-decoration: none;

			.Select-option {
				padding-left: 7px;
			}
		}
	}
`;

export const RowGroupHeaderButtons = styled.div`
	display: flex;
	padding: 12px 14px;
	align-items: center;
	gap: 18px;

	button {
		color: #334155;
	}

	button.trash-can {
		color: #ef4444;
	}
`;

export const ModalTitleLayout = styled.div`
	padding-bottom: 4px;
`;

export const ModalSubtitleLayout = styled.div`
	font-size: 0.56rem;
	padding-bottom: 16px;
	color: #6b6b6b;
`;

export const RadioButtonOptions = styled.div`
	display: flex;
	margin-bottom: 16px;
	gap: 16px;

	div {
		display: flex;
		align-items: center;
		gap: 8px;

		label {
			color: #31363A;
		}
	}
`;